/* eslint-disable */
import * as Types from '../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PinStoryMutationVariables = Types.Exact<{
  projectId: Types.Scalars['String'];
  storyId: Types.Scalars['String'];
}>;


export type PinStoryMutation = { __typename: 'Mutation', pinStory: { __typename: 'Campaign', id: string | null } | null };


export const PinStoryDocument = gql`
    mutation pinStory($projectId: String!, $storyId: String!) {
  pinStory(projectId: $projectId, storyId: $storyId) {
    id
  }
}
    `;
export type PinStoryMutationFn = Apollo.MutationFunction<PinStoryMutation, PinStoryMutationVariables>;

/**
 * __usePinStoryMutation__
 *
 * To run a mutation, you first call `usePinStoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinStoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinStoryMutation, { data, loading, error }] = usePinStoryMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      storyId: // value for 'storyId'
 *   },
 * });
 */
export function usePinStoryMutation(baseOptions?: Apollo.MutationHookOptions<PinStoryMutation, PinStoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PinStoryMutation, PinStoryMutationVariables>(PinStoryDocument, options);
      }
export type PinStoryMutationHookResult = ReturnType<typeof usePinStoryMutation>;
export type PinStoryMutationOptions = Apollo.BaseMutationOptions<PinStoryMutation, PinStoryMutationVariables>;